import React, { createContext, useContext, useState, useMemo, useEffect } from "react";
import { useAuth } from "../login/authProvider";


const CompanyScopeContext = createContext({
  selectedCompany: "",
  setSelectedCompany: () => {}
});

export const CompanyScopeProvider = ({ children }) => {
  const { user } = useAuth();
  const [selectedCompany, setSelectedCompany] = useState("");

  useEffect(() => {
    if (!user) return;

    // Admin: låt UI bestämma (admin väljer själv i dropdown)
    if (user.isAdmin) return;

    const companies = Array.isArray(user.companies) ? user.companies : [];

    // Om user har flera företag: sätt bara initialt om tomt
    if (companies.length > 1) {
      setSelectedCompany((prev) => prev || user.company || companies[0] || "");
      return;
    }

    // Standard (1 företag): beteendet som du har idag
    if (user.company) setSelectedCompany(user.company);
  }, [user]);

  const value = useMemo(
    () => ({ selectedCompany, setSelectedCompany }),
    [selectedCompany]
  );

  return (
    <CompanyScopeContext.Provider value={value}>
      {children}
    </CompanyScopeContext.Provider>
  );
};

export const useCompanyScope = () => useContext(CompanyScopeContext);


/*
const CompanyScopeContext = createContext({
  selectedCompany: "",
  setSelectedCompany: () => {}
});

export const CompanyScopeProvider = ({ children }) => {
  const { user } = useAuth();
  const [selectedCompany, setSelectedCompany] = useState(user?.company || "");

  
  useEffect(() => {
    if (!user?.isAdmin && user?.company) {
      setSelectedCompany(user.company);
    }
  }, [user?.isAdmin, user?.company]);

  const value = useMemo(() => ({ selectedCompany, setSelectedCompany }), [selectedCompany]);

  return (
    <CompanyScopeContext.Provider value={value}>
      {children}
    </CompanyScopeContext.Provider>
  );
};

export const useCompanyScope = () => useContext(CompanyScopeContext);
*/